// extracted by mini-css-extract-plugin
export default {"nodata":"nodata_nodata__A+U0D"};